import model from 'modules/botFlow/botFlowModel';

const { fields } = model;

export default [
  fields.type,
  fields.content,
  fields.subType,
  fields.subject,
  fields.trigger,
  fields.company,
  fields.enable,
];
